<template>
  <div class="page-container">
    <layout :maquina="maquinaAtual" field="oee"></layout>
  </div>
</template>

<script>
import Layout from "../layouts/Major.vue";
import api from "../services/api.js";

import fakeData from "../store/fakeData.js";

export default {
  name: "oee",
  components: {
    layout: Layout
  },
  data: () => ({
    maquinaAtual: {
      ordem: "",
      peca: "",
      codigo: "",
      descricao: "",
      oee: 0,
      desempenho: 0,
      disponibilidade: 0,
      qualidade: 0,
      progress: 0,
      total: 0,
      status: "Indef.",
      faltante: 0,
      atraso: 0,
      tempoEstado: "00:00",
      motivoParada: "",
      historicoOEE: [],
      dataHistoricoOEE: [],
      dateAtual: "00:00",
      indice: -1
    },
    maquinas: [],
    seqsMaquina: [],
    seqFormatado: []
  }),
  async created() {
    let maquinas = [];
    if (this.$store.state.fake) {
      this.maquinas = fakeData;
      this.maquinaAtual = fakeData[0];
    } else {
      this.seqsMaquina = this.$store.state.modeloAtual.PRD057_ASSOC_MODELO_PAR_MAQ.map(
        maquina => maquina.SEQ_PARTE_MAQUINA
      );
      this.seqFormatado = this.seqsMaquina.join(",");
      let res = await api().get(`ObterDadosPartesMaquina/${this.seqFormatado}`);
      maquinas = res.data;

      const primeiraMaq = maquinas[0];
      this.maquinas = maquinas;
      this.setMaquina(primeiraMaq);
      this.rodarMaquinas();
      this.rodarRefresh();
    }
    this.setHoraAtual(this.maquinaAtual.dateAtual);
  },
  methods: {
    rodarMaquinas() {
      const intervalo = setInterval(() => {
        let indiceAtual = this.maquinaAtual.indice;
        let nMaquinas = this.maquinas.length;
        this.setMaquina(this.maquinas[(indiceAtual + 1) % nMaquinas]);
        this.setHoraAtual(this.maquinaAtual.dateAtual);
      }, this.$store.state.timer * 1000);
      this.$on("hook:beforeDestroy", () => {
        clearInterval(intervalo);
      });
    },
    setMaquina(maquina) {
      let indiceAtual = this.maquinaAtual.indice;
      let nMaquinas = this.maquinas.length;
      this.maquinaAtual = {
        ordem: maquina.NUM_OS,
        peca: maquina.COD_PRODUTO,
        codigo: maquina.COD_PARTE_MAQUINA,
        descricao: maquina.DSC_PARTE_MAQUINA,
        oee: maquina.VLR_OEE,
        desempenho: maquina.VLR_DESEMPENHO,
        disponibilidade: maquina.VLR_DISPONIBILIDADE,
        qualidade: maquina.VLR_QUALIDADE,
        progress: maquina.VLR_TOTAL_PRODUZIDO,
        total: maquina.VLR_QUANTIDADE_TOTAL,
        status: maquina.DSC_TIPO,
        faltante: maquina.VLR_QUANTIDADE_FALTANTE,
        atraso: maquina.VLR_QUANTIDADE_ATRASO,
        tempoEstado: maquina.STR_VLR_TEMPO_ESTADO,
        motivoParada: maquina.DSC_MOTIVO_PARADA,
        historicoOEE: maquina.VLR_HISTORICO_OEE,
        dataHistoricoOEE: maquina.DAT_HISTORICO_OEE,
        dateAtual: maquina.STR_HORA_ATUAL,
        indice: (indiceAtual + 1) % nMaquinas
      };
    },
    rodarRefresh() {
      const intervalo = setInterval(() => {
        this.setMaquinaRefresh(this.maquinaAtual.indice);
        this.setHoraAtual(this.maquinaAtual.dateAtual);
      }, 5000);
      this.$on("hook:beforeDestroy", () => {
        clearInterval(intervalo);
      });
    },
    async setMaquinaRefresh(i) {
      let res = await api().get(`ObterDadosPartesMaquina/${this.seqFormatado}`);
      this.maquinas = res.data;

      this.maquinaAtual = {
        ordem: this.maquinas[i].NUM_OS,
        peca: this.maquinas[i].COD_PRODUTO,
        codigo: this.maquinas[i].COD_PARTE_MAQUINA,
        descricao: this.maquinas[i].DSC_PARTE_MAQUINA,
        oee: this.maquinas[i].VLR_OEE,
        desempenho: this.maquinas[i].VLR_DESEMPENHO,
        disponibilidade: this.maquinas[i].VLR_DISPONIBILIDADE,
        qualidade: this.maquinas[i].VLR_QUALIDADE,
        progress: this.maquinas[i].VLR_TOTAL_PRODUZIDO,
        total: this.maquinas[i].VLR_QUANTIDADE_TOTAL,
        status: this.maquinas[i].DSC_TIPO,
        faltante: this.maquinas[i].VLR_QUANTIDADE_FALTANTE,
        atraso: this.maquinas[i].VLR_QUANTIDADE_ATRASO,
        tempoEstado: this.maquinas[i].STR_VLR_TEMPO_ESTADO,
        motivoParada: this.maquinas[i].DSC_MOTIVO_PARADA,
        historicoOEE: this.maquinas[i].VLR_HISTORICO_OEE,
        dataHistoricoOEE: this.maquinas[i].DAT_HISTORICO_OEE,
        dateAtual: this.maquinas[i].STR_HORA_ATUAL,
        indice: i
      };
    },
    setHoraAtual(date) {
      this.$store.commit("gravarDate", { date });
    }
  }
};
</script>
<style scoped>
.page-container {
  padding: 1rem;
  height: 100%;
}
</style>
